import { axiosConfig } from "./config";
import axios from "axios";

export const defaultApiBuilder = (transformResponseMethod) => axios.create({
  ...axiosConfig,
  transformResponse: [
    response => transformResponseMethod(response)
  ]
});

export const defaultApiWithCustomUrlBuilder = (transformResponseMethod) => axios.create({
  ...axiosConfig,
  baseURL: '',
  transformResponse: [
    response => transformResponseMethod(response)
  ]
});